import React from 'react';

import { Chip, Tooltip } from '@mui/material';

export type ScopeChipColor = 'default' | 'info' | 'primary' | 'secondary' | 'warning';

interface Props {
  color: ScopeChipColor;
  tooltip: string;
  value: string;
}

export default function ScopeCell({ color, tooltip, value }: Props) {
  return (
    <Tooltip title={tooltip}>
      <Chip
        color={color}
        label={value}
        size="small"
        sx={{ maxWidth: '100%' }}
        variant={color === 'default' ? 'outlined' : 'filled'}
      />
    </Tooltip>
  );
}
